import React, { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Layout from '../layouts/layout'

const About = lazy(() => import('../pages/about'))
const Home = lazy(() => import('../pages/home'))
const Team = lazy(() => import('../pages/team'))
const Product = lazy(() => import('../pages/product'))
const Consulting = lazy(() => import('../pages/consulting'))
const Industries = lazy(() => import('../pages/industries'))
const NlitenTalentScout = lazy(() => import('../pages/nliten-talent-scout'))

function PageRoute() {
    return (
        <BrowserRouter>
            <Suspense fallback={null}>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/team" element={<Team />} />
                        <Route path="/product" element={<Product />} />
                        <Route path="/consulting" element={<Consulting />} />
                        <Route path="/industries" element={<Industries />} />
                        <Route path="/nliten-talent-scout" element={<NlitenTalentScout />} />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}

export default PageRoute